import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Citation } from 'src/app/models/analyst-output.model';
import { CitationPanelService } from 'src/app/services/citation-panel.service';
import { getCitationTypeLabel, shortenCitationLabel, stripLeadingTypeWord } from 'src/app/shared/utils/citation-preview.util';
import { CitationMarker } from 'src/app/shared/utils/citation-resolver.util';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { CitationOverflowRow } from './citation-overflow.model';

@Component({
  standalone: false,
  selector: 'app-citation-overflow',
  templateUrl: './citation-overflow.component.html',
  styleUrls: ['./citation-overflow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CitationOverflowComponent {
  rows: CitationOverflowRow[] = [];

  readonly trackByIndex = trackByIndex;

  @Input()
  set markers(value: readonly CitationMarker[]) {
    this.rows = (value ?? []).map((marker) => {
      const typeLabel = getCitationTypeLabel(marker.citation);
      return {
        marker,
        typeLabel,
        label: stripLeadingTypeWord(shortenCitationLabel(marker.citation.label), typeLabel),
        fullLabel: marker.citation.label,
      };
    });
  }

  constructor(private readonly citationPanelService: CitationPanelService) {}

  onRowClick(event: MouseEvent, citation: Citation): void {
    this.citationPanelService.openMarkerFromClick(event, citation);
  }
}
